import { styled, Stack, Button } from '@mui/material';

export const ProfileContainer = styled(Stack)(() => ({
  width: '70vw',
  gap: '3rem',
}));

export const ResetPasswordButton = styled(Button)(({ theme }) => ({
  height: 35,
  width: '100%',
  borderRadius: 8,
  fontWeight: 500,
  fontSize: 14,
  padding: '5px 25px',
  textTransform: 'none',
  display: 'flex',
  outline: 'none',
  justifyContent: 'space-between',
  color: theme.palette.blue.main,
  backgroundColor: theme.palette.blue400.main,
  '&:focus': {
    ouline: 'none',
  },
}));
